import fetch from 'isomorphic-fetch';
import moment from 'moment';
import {CURRENT_STAGE, ENV_PRODUCTION} from "../constants/enum";

const API_URL = process.env.REACT_APP_VENUE_API_URL || `https://prod-api.vmnk.in/venue-service`
// const API_URL = `http://localhost:8080/venue-service`;

export default function callVenueApi(endpoint, method = 'get', body) {
    let token = window.localStorage.getItem('token') ?  window.localStorage.getItem('token') : '';
    // let token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJfaWQiOiI1OGI2YWNkMWYzNmQyODFmYWNiNzU2ODgiLCJuYW1lIjoiUml0d2lrIFNhaG9vIiwiaXNfMmZhX3JlcXVpcmVkIjpmYWxzZSwiaXNfMmZhX2VuYWJsZWQiOmZhbHNlLCJhY2Nlc3NfbGV2ZWwiOjAsImlzQWRtaW4iOnRydWUsImhvc3QiOiJhZG1pbiIsInNvdXJjZSI6ImFnZW50LWxvZ2luIiwiaWF0IjoxNzQ0Njk2NjU0fQ.wZdfUAYyesaIdRppLlfpVnb7uxbwbjJofmeYpWC5TF0"
    let headers = {};
    headers['content-type'] = 'application/json';
    if (token && token !=='') {
        headers.Authorization = `Bearer ${token}`;
    }
    return fetch(`${API_URL}/${endpoint}`, {
        headers: headers,
        method,
        body: JSON.stringify(body),
    })
        .then(response => response.json().then(json => ({json, response})))
        .then(({json, response}) => {
            if (!response.ok) {
                return Promise.reject(json);
            }
            return json;
        })
        .then(
            response => response,
            error => error
        );
}

export function callVenueApiAndCache(endpoint, method = 'get', body, expireHour) {
    let token = window.localStorage.getItem('token') ?  window.localStorage.getItem('token') : '';
    let headers = {};
    headers['content-type'] = 'application/json';
    if (token && token !=='') {
        headers.Authorization = `Bearer ${token}`;
    }
    let cacheResponse = window.localStorage.getItem(`event-api/${endpoint}`);
    if (cacheResponse) {
        let parsedResponse = JSON.parse(cacheResponse);
        if (parsedResponse.expires && moment(parsedResponse.expires).isAfter(moment())) {
            return Promise.resolve(parsedResponse.data);
        }
    }
    return fetch(`${API_URL}/${endpoint}`, {
        headers: headers,
        method,
        body: JSON.stringify(body),
    })
        .then(response => response.json().then(json => ({json, response})))
        .then(({json, response}) => {
            if (!response.ok) {
                return Promise.reject(json);
            }
            let cachedResponse = {
                data:  json,
                expires: moment().startOf('hour').add(expireHour ? expireHour : 1, 'hour').toISOString()
            }
            window.localStorage.setItem(`api/${endpoint}`, JSON.stringify(cachedResponse));
            return json;
        })
        .then(
            response => response,
            error => error
        );
}
